module.exports = __webpack_public_path__ + "img/qy (53).0af2dabe.jpg";